import { useCallback } from 'react';
import { ContentType, ProgressForLessons, ProgressForCourses } from '@atlassian/learning-components';

import { LearningProgressStatus } from 'src/services/http/progress';
import { navigateToNextItem } from 'src/pages/utils/navigation';

interface NavigationItem {
  sys: {
    id: string;
  };
  slug: string;
  lessonsCollection?: {
    items: {
      sys: { id: string };
      slug: string;
    }[];
  };
}

interface StartContentOptions {
  items: NavigationItem[] | undefined;
  progress: ProgressForCourses | ProgressForLessons | undefined;
  contentSlug: string;
  contentType: ContentType.COURSE | ContentType.LEARNING_PATH;
  userId?: string;
  navigateToItem: (slug: string) => void;
  fieldId: string;
  navigateToLesson?: (lessonSlug: string, courseSlug: string) => void;
  lessonsProgress?: ProgressForLessons;
}

export const useStartContent = ({
  items,
  progress,
  contentSlug,
  contentType,
  userId,
  navigateToItem,
  fieldId,
  navigateToLesson,
  lessonsProgress,
}: StartContentOptions): (() => void) =>
  useCallback(() => {
    if (!items?.length) {
      return;
    }

    const defaultProgress =
      contentType === ContentType.COURSE
        ? {
          overallStatus: progress?.overallStatus || LearningProgressStatus.NOT_STARTED,
          lessons: (progress as ProgressForLessons)?.lessons || [],
        }
        : {
          overallStatus: progress?.overallStatus || LearningProgressStatus.NOT_STARTED,
          courses: (progress as ProgressForCourses)?.courses || [],
        };

    navigateToNextItem({
      items,
      progress: defaultProgress,
      itemIdField: fieldId,
      contentSlug,
      contentType,
      userId,
      navigateToItem,
      navigateToLesson,
      lessonsProgress,
    });
  }, [items, progress, fieldId, contentSlug, contentType, userId, navigateToItem, navigateToLesson, lessonsProgress]);
